module.exports = __webpack_public_path__ + "static/media/walterwhite.bc94d69a.png";